// ScrollContainer.js - 基类组件
import React from 'react';
import { withRouter } from 'react-router-dom'
import { universitiesList } from './Universities'
import LazyImage from './components/lazyImage.jsx';
import Header from './components/header.jsx';
import Footer from './components/footer.jsx';



class Sgsummer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: 0
        };


    }

    componentDidMount() {



    }

    onToggleTab = (value) => {
        this.setState({ currentTab: value })


    }


    render() {

        return (
            <div className={`flex-col`}>
                <Header activeMenu='8' />
                <div className='dv_vpm_body'>
                    <div className={`flex-col dv_vpm_main_body`}>
                        <div className='dv_banner_wrap'><img src={require("./assets/img/sgsummer/1.jpg")} /></div>
                        <div className='dv_vpm_content_wrap'>
                            <div className='dv_trake_change flex-row between'>
                                <div className={this.state.currentTab == 0 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(0)}>为什么去新加坡</div>
                                <div className={this.state.currentTab == 1 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(1)}>多元化研学</div>
                                <div className={this.state.currentTab == 2 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(2)}>世界名校参访</div>
                                <div className={this.state.currentTab == 3 ? 'tab selected tablast' : 'tab clickable'} onClick={() => this.onToggleTab(3)}>报名须知</div>
                            </div>
                            {this.state.currentTab == 0 && <div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/2.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/3.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/4.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/5.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/6.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/7.jpg")} /></div>

                            </div>}
                            {this.state.currentTab == 1 && <div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/8.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/9.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/10.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/11.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/12.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/13.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/14.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/15.jpg")} /></div>
                            </div>}
                            {this.state.currentTab == 2 && <div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/16.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/17.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/18.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/19.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/20.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/21.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/22.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/23.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/24.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/25.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/26.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/27.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/28.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/29.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/30.jpg")} /></div>
                            </div>}
                            {this.state.currentTab == 3 && <div>
                                <div><LazyImage imgUrl={require("./assets/img/sgsummer/31.jpg")} /></div>
                            </div>}
                        </div>
                    </div>


                </div>
                <Footer />
            </div>
        );
    }
}

export default withRouter(Sgsummer);